import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "pagestyle" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "dialog-footer" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Members',
  setup(__props) {

  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    userbox:false,
  })
  const formData:any = reactive({
    modeltype:0,
    inimg:"",
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const showInCode = (id:number) => {
    baseData.userbox = true
    formData.id = id
    formData.modeltype = 0
    formData.inimg = ""
  }
  const createIncode = () => {
    const loading = ElLoading.service({
      lock: true,
    })
    api.memberApi.createIncode({id:formData.id,modeltype:formData.modeltype}).then((res:any)=>{
      loading.close()
      if(res.code==200){
        formData.inimg = res.data.img
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    baseData.loading = true
    api.memberApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    api.memberApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const del = (id:number) => {
    baseData.loading = true
    api.memberApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("用户列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "nickname",
              label: "昵称"
            }),
            _createVNode(_component_el_table_column, {
              label: "头像",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                (scope.row.avatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: scope.row.avatar,
                      style: {"width":"100px","height":"100px","border-radius":"10px"}
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "ip",
              label: "登录IP",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "login_time",
              label: "登录时间",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "创建时间",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 0,
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_text, {
                      key: 1,
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("冻结")
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (showInCode(scope.row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("获取邀请码")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (scope.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 0,
                      "confirm-button-text": "是",
                      "cancel-button-text": "否",
                      title: "确定设置冻结吗?",
                      onConfirm: ($event: any) => (changeStatus(scope.row.id,0))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("设置冻结")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "small",
                      onClick: ($event: any) => (changeStatus(scope.row.id,1)),
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("设置正常")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.userbox,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((baseData.userbox) = $event)),
      title: "邀请码"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: createIncode
          }, {
            default: _withCtx(() => [
              _createTextVNode("生成邀请码")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (baseData.userbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: formData,
          "label-width": "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "邀请码" }, {
              default: _withCtx(() => [
                (formData.inimg)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: 'https://img.go.996w.cn/' + formData.inimg,
                      class: "avatar"
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "充值模式" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.modeltype,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.modeltype) = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})